'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Init = void 0;
const $ = require("jquery");
class Init {
    constructor() {
        $(window).on('load', () => {
            const href = location.href;
            if (this.isAnchor(href)) {
                // 要素があったら対応する
                if (this.isIdName(href)) {
                    this.switchShowContent(href);
                    $("html, body").animate({ scrollTop: 0 }, 0, 'linear');
                    setTimeout(() => {
                        this.scrollToAnchor(href);
                    }, 300);
                    return false;
                }
            }
        });
    }
    // #があるかどうかの判定処理
    isAnchor(href) {
        return href.indexOf('#') != -1;
    }
    // コンテンツの切り替え
    switchShowContent(href) {
        const name = this.getAnchorName(href);
        if (!(name === 'interview' || name === 'print')) {
            $('.bulletTabContent').hide();
            $('#' + name).show();
            this.switchTabButton(name);
        }
    }
    // タブボタンの切り替え
    switchTabButton(name) {
        const number = $(`.bulletTabContent + #${name}`).attr('data-number');
        $('.trigTabContent').attr('data-is-show', 'false');
        $(`.trigTabContent[data-number="${number}"]`).attr('data-is-show', 'true');
    }
    // スクロール処理
    scrollToAnchor(href) {
        const anchor = this.getAnchorName(href);
        const position = $('#' + anchor).offset().top;
        $("html, body").animate({ scrollTop: position }, 400, 'linear');
    }
    // #の名前を取得
    getAnchorName(href) {
        const index = href.indexOf('#');
        return href.slice(index + 1);
    }
    // ID要素存在チェック
    isIdName(href) {
        const name = this.getAnchorName(href);
        const length = $(`#${name}`).length;
        let isElement = false;
        if (length !== 0) {
            isElement = true;
        }
        return isElement;
    }
}
exports.Init = Init;
exports.default = Init;
